import { createContext, useContext, useEffect, useState } from 'react';
import apiClient from '../api/apiClient';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const client = apiClient('iam');
        const res = await client.get('/iam/me', { withCredentials: true });
        setUser(res.data);
      } catch (err) {
        setUser(null);
      } finally {
        setAuthChecked(true);
      }
    };
    fetchUser();
  }, []);

  const logout = async () => {
    try {
      const client = apiClient('iam');
      await client.post('/iam/logout', null, { withCredentials: true });
    } catch (err) {
      console.error('Logout failed:', err);
    }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, authChecked, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
